import React from 'react';
import { Heart, MapPin, Phone, Mail, Clock } from 'lucide-react';
import { openTrackOrder } from '../orders/TrackOrderModal';

export function Footer() {
  return (
    <footer className="bg-ndms-navy-dark text-gray-300">
      <div className="container-max section-padding py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2.5 mb-4">
              <div className="w-9 h-9 bg-white/10 rounded-xl flex items-center justify-center">
                <Heart size={18} className="text-white fill-white" />
              </div>
              <div>
                <div className="font-bold text-white leading-tight">Northdale</div>
                <div className="text-xs text-gray-400 leading-tight">Medical Supplies</div>
              </div>
            </div>
            <p className="text-sm text-gray-400 leading-relaxed">
              Trusted source for medical-grade compression stockings and orthopedic bracing. Serving our community with care.
            </p>
          </div>

          {/* Products */}
          <div>
            <h3 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Products</h3>
            <ul className="space-y-2 text-sm">
              {['Compression Stockings', 'Back Braces', 'Knee Braces', 'Ankle Braces', 'Wrist Braces', 'Elbow Braces'].map((item) => (
                <li key={item}>
                  <span className="text-gray-400 cursor-default">{item}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Brands */}
          <div>
            <h3 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Our Brands</h3>
            <ul className="space-y-2 text-sm">
              {['Sigvaris', 'Relaxsan', 'OTC Brace'].map((brand) => (
                <li key={brand}>
                  <span className="text-gray-400">{brand}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Contact</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2.5">
                <MapPin size={15} className="text-ndms-teal-light flex-shrink-0 mt-0.5" />
                <span className="text-gray-400">7-510 44 Street East<br />Saskatoon, SK S7K 0W1</span>
              </li>
              <li className="flex items-center gap-2.5">
                <Phone size={15} className="text-ndms-teal-light flex-shrink-0" />
                <a href="tel:+13069794115" className="text-gray-400 hover:text-white transition-colors">
                  306-979-4115
                </a>
              </li>
              <li className="flex items-center gap-2.5">
                <Mail size={15} className="text-ndms-teal-light flex-shrink-0" />
                <a href="mailto:northdalesask@gmail.com" className="text-gray-400 hover:text-white transition-colors">
                  northdalesask@gmail.com
                </a>
              </li>
              <li className="flex items-start gap-2.5">
                <Clock size={15} className="text-ndms-teal-light flex-shrink-0 mt-0.5" />
                <div className="text-gray-400">
                  <div>Tue–Fri: 11am – 6pm</div>
                  <div>Sat: 10am – 2pm</div>
                  <div>Sun, Mon: Closed</div>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-gray-500">
          <p>© {new Date().getFullYear()} Northdale Medical Supplies. All rights reserved.</p>
          <div className="flex items-center gap-4">
            <button onClick={openTrackOrder} className="text-gray-400 hover:text-white transition-colors underline-offset-2 hover:underline">
              Track your order
            </button>
            <p>Orders fulfilled manually by our staff.</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
